import { OrderInfoController } from '../controllers/orderInfoController';
import templateUrl from './orderInfo.html';

export const OrderInfoComponent = {
    bindings: {
        previousCart: '<'
    },
    templateUrl,
    restrict: 'E',
    controller: OrderInfoController
};
